import styled from 'styled-components';
import Media from 'components/Media';
import { mediaDesktop } from '../../breakpoints';

export const PackBattleWrapper = styled.div`
  position: relative;
  margin: 60px 20px 10px;
  padding: 1px;
  border-radius: 8px;
  background: linear-gradient(78deg, #e264a3 0%, #03fdfd 100%);

  &:before {
    content: '';
    display: block;
    position: absolute;
    margin: auto;
    width: 5%;
    min-width: 130px;
    height: 1px;
    top: 0;
    left: 0;
    right: 0;
    background: #000000;

    ${mediaDesktop} {
      min-width: 220px;
    }
  }

  ${mediaDesktop} {
    margin: 100px auto 0;
    max-width: 1064px;
  }
`;

export const PackBattleRow = styled.div`
  display: block;
  border-radius: 8px;
  background: linear-gradient(to top, #241c23, #000000), linear-gradient(78deg, #e264a3 0%, #03fdfd 100%);

  ${mediaDesktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const PackBattleColumn = styled.div<{ $grid?: boolean }>`
  padding: 30px 25px;

  ${({ $grid }) => $grid && `
    display: grid;
    grid-template-columns: 1fr 56px;
    grid-column-gap: 25px;
    padding-top: 0;
    padding-bottom: 5px;
  `}

  ${({ $grid }) => !$grid && `
    padding-bottom: 20px;
  `}
  
  ${mediaDesktop} {
    padding: 48px 50px 42px;

    & ~ &:before {
      content: '';
      position: absolute;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: calc(100% - 48px * 2);
      width: 1px;
      background: #FFFFFF;
      opacity: 0.2;
    }

    ${({ $grid }) => $grid && `
      display: grid;
      grid-template-columns: 62px 1fr;
      grid-column-gap: 32px;
      padding-left: 63px;
      padding-top: 44px;
      padding-bottom: 30px;
    `}

    ${({ $grid }) => !$grid && `
      margin: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    `}
  }
`;

export const PackBattleAvatar = styled(Media)<{ $counter?: number }>`
  position: relative;
  margin-top: -5px;
  width: 56px;
  height: 56px;
  border-radius: 100%;
  grid-row-start: 1;
  grid-row-end: 4;
  grid-column: 2 / 2;

  ${({ $counter }) => $counter && `
    &:before {
      content: '${$counter}';
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 100%;
      font-family: ${({ theme }) => theme.fonts.primary};
      font-size: 32px;
      font-weight: bold;
    }
  `}

  ${mediaDesktop} {
    margin-top: -7px;
    width: 62px;
    height: 62px;
    grid-column: 1 / 2;
  }
`;

export const PackBattleTitle = styled.h3`
  position: absolute;
  margin: -3px auto 0;
  top: 0;
  left: 0;
  right: 0;
  transform: translateY(-35%);
  color: #20e6e7;
  font: 20px/1 ${({ theme }) => theme.fonts.secondary};
  text-align: center;
  letter-spacing: 1px;

  ${mediaDesktop} {
    font-size: 40px;
    letter-spacing: 2px;
    text-shadow: 0 0 5px #000000;
  }
`;

export const PackBattleHeadline = styled.h4`
  color: #FFFFFF;
  font: 18px/1 ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.71px;

  ${mediaDesktop} {
    grid-column: 2 / 2;
    font-size: 21px;
    letter-spacing: 2px;
  }
`;

export const PackBattleSubline = styled.p`
  margin: 4px 0 20px;
  color: #20e6e7;
  font: 18px/29px ${({ theme }) => theme.fonts.primary};
  letter-spacing: 1.71px;
  text-overflow: ellipsis;
  overflow: hidden;

  a {
    text-decoration: none;
    color: inherit;
  }
  
  ${mediaDesktop} {
    margin: 8px 0 14px;
    grid-column: 2 / 2;
    font-size: 21px;
    letter-spacing: 2px;
  }
`;

export const PackBattleCopy = styled.p`
  margin-top: 10px;
  color: #FFFFFF;
  font: 15px/1.5 ${({ theme }) => theme.fonts.primary};

  ${mediaDesktop} {
    margin-top: 18px;
    font-size: 16px;
    line-height: 1.88;
    letter-spacing: 0.3px;
  }
`;
